<template>
  <div class="apply_box">
    <div class="header"
         v-for="(item,index) in applyingTop"
         :key="index">
      <div class="succ_bg_act"
           :class="{'ws18':'0'==item.statusString,'ws43':'1'==item.statusString,'ws66':'2'==item.statusString,'ws75':'3'==item.statusString}"></div>
      <!-- item.statusList.length-1==item.statusString -->
      <div class="top_bg"></div>
      <div class="succ_bg">
        <div class="item"
             v-for="(itm,idx) in item.statusList"
             :key="idx">
          <span class="de_icon"
                :class="{'ing_icon':item.statusString == idx,'succ_icon':item.statusList.length-1==item.statusString || idx<item.statusString }"></span>
        </div>
      </div>
      <div class="box">
        <div class="item"
             v-for="(itm,idx) in item.statusList"
             :key="idx">
          <span :class="{'cl_bl':item.statusString == idx}">{{itm}}</span>
        </div>
      </div>
      <p class="title"
         v-show="item.statusString != 2">{{item.title}}</p>
      <div class="btn_box"
           v-show="item.pageUrl!==''">
        <p class="btn"
           @click="toLoanMoney(item.pageUrl)">{{item.title}}</p>
        <p class="info">{{item.rightTitle}}</p>
      </div>
    </div>
    <div class="bg"></div>
    <!-- 广告位 -->
    <div class="banner"
         v-if="advertList.length>0">
      <div class="ban_item"
           v-for="(item,index) in advertList"
           :key="index">
        <a class="bann_a"
           :href="item.pageUrl">
          <img :src="item.imageUrl"
               alt="">
        </a>
      </div>
    </div>
    <div class="bg"></div>
    <div class="pro_detail"
         v-if="bigList.length>0">
      <div class="pro_item">
        <h1 class="h1"><span class="line"></span> {{bigJson.title}}</h1>
      </div>
      <div class="pro_item"
           v-for="(item,index) in bigList"
           :key="index">
        <p>{{item.title}}</p>
        <p>{{item.rightTitle}}</p>
      </div>
    </div>
    <div class=""
         v-if="allList.length>0">
      <div class="pro_detail"
           v-for="(item,index) in allList"
           :key="index">
        <div class="pro_item"
             v-if="item.head && item.head.isShow==1">
          <h1 class="h1"><span class="line"></span> {{item.head.title}} </h1>
        </div>
        <div class="pro_item"
             v-for="(itm,idx) in item.content"
             :key="idx+'pi'">
          <p>{{itm.title}}</p>
          <p>{{itm.rightTitle}}</p>
        </div>
        <div class="foot"
             v-if="item.foot && item.foot.isShow==1">
          <p>{{item.foot.describe}} <span v-for="(itm,idx) in item.foot.footClick"
                  :key="idx"><a :href="itm.pageUrl">{{itm.title}}</a></span></p>

        </div>
        <div class="bg"></div>
      </div>
    </div>
    <div class="bg"></div>

    <LoanList v-if="orderList.length>0"
              :orderList="orderList"
              :orderTitleJson="orderTitleJson" />
  </div>
</template>

<script>
import LoanList from '@/components/loanList';
export default {
  components: {
    LoanList,
  },
  data () {
    return {
      // status: 6,
      orderId: '',
      applyingTop: [],//头部状态渲染
      orderList: [],//下面列表
      orderTitleJson: {},//列表titlejson
      bigList: [],//中间部分
      allList: [],
      advertList: [],
    }
  },
  mounted () {
    this.orderId = this.$route.query.orderId;
    this.util.title('产品名称');
    this.getDetails();
  },
  methods: {
    getDetails () {
      let param = {
        orderId: this.orderId
      }
      let _this = this;
      this.$get('/app/api/v1/order/details', param)
        .then(res => {
          var e = res;
          if (e.code == 200) {
            _this.util.title(e.data.productName);
            e.data.appOrderCells.map(function (item) {
              if (item.type == "product") {
                _this.orderList = item.content//产品列表
                _this.orderTitleJson = item.head;
              } else if (item.type == "bigList") {
                _this.bigList = item.content//
                _this.bigJson = item.head;
              } else if (item.type == "applyingTop") {
                if (item.content[0].statusList[2] == '已拒绝' || item.content[0].statusList[2] == '审核不通过') {
                  item.content[0].statusString = 3
                }
                _this.applyingTop = item.content;

              } else if (item.type == "smallList") {
                _this.allList.push(item);
              } else if (item.type == "advert") {
                _this.advertList = item.content
              }
            })
          }
          else {
            _this.util.toast({ msg: e.msg })
          }
        })
        .catch(error => { });
    },
    toLoanMoney (pageUrl) {
      let param = {
        pageUrl: pageUrl
      }
      if (pageUrl.indexOf("http") == "-1") {
        //跳到客户端页面——产品详情页面
        try {
          window.webkit.messageHandlers.toProductDetail.postMessage(param);//ios
        } catch (err) {
          window.AppJs.toProductDetail(JSON.stringify(param));//android
        }
      } else {
        window.location.href = pageUrl;
      }
    }
  }
}
</script>
<style scoped>
.apply_box {
  background: #ffffff;
}
.bg {
  background: #f7f7f7;
  width: 100%;
  height: 0.1rem;
}
.header {
  padding: 0.3rem 0 0.22rem 0;
  /* margin-bottom: 0.1rem; */
  background: #ffffff;
  position: relative;
}
.left_icon {
  position: absolute;
  left: -0.1rem;
}
.right_icon {
  position: absolute;
  right: -0.1rem;
}
.item {
  z-index: 11;
  color: #999;
}
.cl_bl {
  color: #486cff;
}
.succ_bg,
.succ_bg_act {
  position: relative;
  width: 80%;
  margin: 0 auto;
  /* width: 80%;
  height: 0.09rem;
  background: url("../../assets/img/afterLoan/bg.png") no-repeat top center;
  background-size: 100% 100%;
  margin: 0 auto; */
  display: flex;
  flex: 1;
  justify-content: space-between;
}
.top_bg {
  position: relative;
  top: 0.07rem;
  width: 78%;
  height: 0.09rem;
  background: url("../../assets/img/afterLoan/bg.png") no-repeat top center;
  background-size: 100% 100%;
  margin: 0 auto;
}
.succ_bg_act {
  position: absolute;
  background: url("../../assets/img/afterLoan/bg_ing.png") no-repeat top center;
  background-size: 100% 100%;
  margin: 0 auto;
  width: 78%;
  /* 30,40,50,65,80 */
  z-index: 1;
  left: 11%;
  height: 0.09rem;
  top: 0.36rem;
}
.ws18 {
  width: 18%;
}
.ws43 {
  width: 43%;
}
.ws66 {
  width: 66%;
}
.ws75 {
  width: 75%;
}
.box {
  display: flex;
  flex: 1;
  justify-content: space-between;
  position: relative;
  width: 85%;
  margin: 0 auto;
}
.ps {
  margin-top: 0.2rem;
  position: relative;
  top: 0.15rem;
}
.t25 {
  top: 0.25rem;
}
.de_icon,
.ing_icon,
.succ_icon {
  display: inline-block;
  width: 0.25rem;
  height: 0.25rem;
  background: url("../../assets/img/afterLoan/default.png") no-repeat top center;
  background-size: 100% 100%;
}
.ing_icon,
.succ_icon {
  margin-top: -0.05rem;
  width: 0.35rem;
  height: 0.35rem;
  background: url("../../assets/img/afterLoan/ing.png") no-repeat top center;
  background-size: 100% 100%;
}
.succ_icon {
  background: url("../../assets/img/afterLoan/succ.png") no-repeat top center;
  background-size: 100% 100%;
}
.succ_bg .item {
  margin-top: -0.1rem;
  text-align: center;
}
.title {
  color: #999;
  font-size: 0.2rem;
  text-align: center;
  margin-top: 0.2rem;
}
.info {
  font-size: 0.12rem;
  color: #999;
  text-align: center;
  margin-top: 0.1rem;
}
.pro_item {
  padding: 0.15rem;
  border-bottom: 1px solid #eee;
  display: flex;
  flex: 1;
  justify-content: space-between;
}
.h1 {
  font-size: 0.16rem;
  color: #333;
}
.line {
  display: inline-block;
  width: 3px;
  height: 0.12rem;
  background: #486cff;
}
.btn {
  color: #ffffff;
  font-size: 0.17rem;
  text-align: center;
  background: linear-gradient(
    90deg,
    rgba(122, 157, 246, 1) 0%,
    rgba(81, 117, 241, 1) 100%
  );
  box-shadow: 0px 6px 10px 0px rgba(228, 238, 250, 1);
  border-radius: 25px;
  height: 0.5rem;
  line-height: 0.5rem;
  width: 90%;
  margin: 0 auto;
  margin-top: 0.2rem;
}
.foot {
  padding: 0.15rem;
}
.foot span {
  color: #486cff;
}
.banner {
  width: 100%;
  display: flex;
  flex: 1;
  justify-content: space-around;
  height: 1rem;
  align-items: center;
}
.banner .ban_item {
  flex: 1;
  text-align: center;
}
.banner img {
  width: 100%;
}
.banner .bann_a {
  display: inline-block;
}
</style>